module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/weather/snow-2-57c863fb285baf5cf09a65879a3b0195.svg";